<template>
	<paginated-results
	  v-slot="{ doSearch, empty, hasNextPage, hasPrevPage, loading, nextPage, prevPage, refresh, results,page, pages,total }"
	  v-bind="{
		action,
		filters: {
		  status: ['NEW', 'DELIVERED', 'FAILED', 'CANCELLED'],
		},
		search: newSearch,
	    perPage,
		sort,
		sortDescending,
	  }"
	>
	    <b-container fluid class="mt-4">
			<b-row>
				<b-col cols="12" md="12" lg="4" order="1" class="mb-4 mb-lg-0">
					<b-form @submit.prevent="doSearch">
						<search-input v-model="newSearch" v-bind="{ loading }" />
					</b-form>
				</b-col>
				<b-col cols="6" md="6" lg="2" order="2" class="text-left text-md-left text-lg-left d-flex align-items-center">
						<!-- Badge -->
						<b-badge v-if="loading" class="text-bold p-2 m-0 d-flex align-items-center justify-content-center" pill  style="color:white; background-color:#f59e59; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
							Loading...
						</b-badge>
						<b-badge v-else-if="total > 0" class="text-bold p-2 m-0 d-flex align-items-center justify-content-center" pill style="color:white; background-color:#f59e59; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
							<span style="font-size: 1.5em;">{{ total.toLocaleString() }}</span>
						</b-badge>
				</b-col>
				<b-col cols="6" md="6" lg="6" order="3" class="text-right">
						<div  class="d-flex justify-content-end align-items-center">
						<p class="font-weight-bold small text-muted mb-0 mr-3">
							Page {{ page }} / {{ pages }}
						</p>
						<simple-pagination v-bind="{ loading, nextPage, prevPage, hasPrevPage, hasNextPage }" />
						</div>
				</b-col>
			</b-row>
		</b-container>

		<b-container v-if="loading && empty" class="my-4">
			<loading-indicator size="4x" class="my-5" />
		</b-container>
		<b-container fluid v-else-if="!empty" class="mt-4">
			<b-row>
				<b-col cols="12" class="mb-4">
					<ResultTable
						:data="results"
						:loading="loading"
						:sort.sync="sort"
						:sort-descending.sync="sortDescending"
						@row-clicked="onRowClick"
						
					/>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid v-else class="my-4">
			<empty-result>
				No new documents
				<template #content> Completed packets from appeals will appear here. </template>
			</empty-result>
		</b-container>
			
	    <b-modal
			v-model="showDetailsModal"
			title="Document Details"
			size="lg"
			hide-footer
			hide-header
	    >
			<div>
			<div class="d-flex justify-content-between"> 
				<h4>Outgoing {{ selectedItem?.delivery_method }}</h4>
				<b-badge :variant="selectedItem?.progress_variant" pill class="b-badge-lg b-badge-lg-custom d-inline-block d-sm-inline-flex align-items-center">
				{{ selectedItem?.status_label }}
				</b-badge>
			</div>
			<hr>
			<p><font-awesome-icon icon="user" /><strong> Patient Name:</strong> {{ selectedItem?.case?.patient?.list_name ?? "(Missing Name)" }}</p>
			<p><font-awesome-icon icon="building" class="px-0 mx-0" /><strong> Facility:</strong> {{ selectedItem?.facility_name }}</p>
			<p><font-awesome-icon icon="user-md" class="px-0 mx-0" /><strong> Recipient Name:</strong> {{ selectedItem?.submit_to ?? "(Missing)" }}</p>
			<p><font-awesome-icon icon="building" class="px-0 mx-0" /><strong> Recipient Type:</strong> {{ selectedItem?.name_of_submit_to }}</p>
			<div>
				<p v-if="selectedItem?.request_id && selectedItem?.request_type != 'MedicalRecord'"> <font-awesome-icon icon="envelope" /><strong> Level:</strong> {{  selectedItem?.appeal_level_name }} <span :class="selectedItem?.case_request?.deleted !== null ? 'circle-badger' : 'circle-badge'">R</span></p>
				<p v-if="selectedItem?.request_type == 'MedicalRecord'"> <font-awesome-icon icon="envelope" /><strong> Level:</strong> {{  selectedItem?.appeal_level_name }} <span :class="selectedItem?.case_request?.deleted !== null ? 'mr-badger' : 'mr-badge'">MR</span></p>
				<p v-else-if="!selectedItem?.request_id && selectedItem?.request_type != 'MedicalRecord'"><font-awesome-icon icon="envelope-open" /><strong> Level:</strong> 
					{{  selectedItem?.appeal_level_name }}</p>
			</div>
			<div>
				<p v-if=" selectedItem?.email"> <font-awesome-icon
											v-if="selectedItem?.delivery_method_icon"
											:icon="selectedItem?.delivery_method_icon"
											fixed-width
										/><strong> Email:</strong> {{ selectedItem?.email}}</p>
			<p v-if="selectedItem?.fax">
				<font-awesome-icon
											v-if="selectedItem?.delivery_method_icon"
											:icon="selectedItem?.delivery_method_icon"
											fixed-width
										/><strong> Fax:</strong> {{  selectedItem?.fax }}</p>
			</div>
			<p v-if="selectedItem?.request_level_name "><font-awesome-icon icon="envelope" class="px-0 mx-0" /><strong> Request Details :</strong> {{ selectedItem?.request_level_name}}</p>
			<p v-if="selectedItem?.request_type">		
  
    <font-awesome-icon icon="envelope" class="px-0 mx-0" />
    <strong> Request Type :</strong> {{ selectedItem?.request_type === 'MedicalRecord' ? "Medical Record" : selectedItem?.request_type  }}
  </p>
 

			<p><strong>Sent Date:</strong> {{ $filters.formatDate(selectedItem?.created) }}</p>
			<div v-if="selectedItem?.delivery_method === 'Mail' || 'MAIL'">
				<p v-if="selectedItem?.mailNotes "><strong>Mail Notes:</strong> {{ selectedItem?.mailNotes }}</p>
				<p v-if="selectedItem?.carrier  "><strong>Carrier:</strong> {{ selectedItem?.carrier }}</p>
				<p v-if="selectedItem?.tracking "><strong>Tracking:</strong> {{ selectedItem?.tracking }}</p>
			</div>
			<div>
						<b-dropdown right class="mb-0">
								<template #button-content>
									<font-awesome-icon icon="file-download" fixed-width />
								</template>
								<b-dropdown-item
								@click="download(selectedItem)" title="Download Packet"
								>
									Download
								</b-dropdown-item>
								<b-dropdown-item
									@click="preview(selectedItem)"
								>
									Preview
								</b-dropdown-item>
							</b-dropdown>
		
				</div>
			
			</div>
			<hr>
			<div class="d-flex justify-content-between mt-1">
				<b-button @click="showDetailsModal = false" variant="light" class="btn btn-outline-danger">Close</b-button>
					<div v-if="selectedItem?.appeal === null">
							<font-awesome-icon icon="exclamation-triangle" class="text-warning" />
							This appeal is deleted.
					</div>
					<div v-else-if="selectedItem?.request_id && selectedItem?.case_request?.deleted !== null">
							<font-awesome-icon icon="exclamation-triangle" class="text-warning" />
							This request is deleted.
					</div>
				<b-button v-else @click="navigateToAppeal" variant="light" class="btn btn-outline-primary">View Case</b-button>
			</div>
	    </b-modal>
	</paginated-results>
  </template>
  
  <script>
  import { ref } from "vue";
  import { getIndex } from "@/clients/services/outgoingDocuments";
  import ResultTable from "@/clients/components/OutgoingDocuments/Table.vue";
  import store from "@/clients/store";
  import axios from "axios";
  
  export default {
	name: 'OutgoingDocuments',
	 components: {
    ResultTable,
    },
	data() {
	  return {
		newSearch: '',
		perPage: 15,
		action: getIndex,
		showDetailsModal: false,
		selectedItem: null,
		sort: 'created',
		sortDescending : true,
	  };
	},
	
	methods: {
		
		onRowClick(item) {
			this.selectedItem = {
			...item,
			};
			
			this.showDetailsModal = true;
		},
		preview(selectedItem) {
		  
		  const pdfUrl = `/client/api/appeals/${selectedItem.id}/pdf?param=${selectedItem.filename}` ;
		
		  if (pdfUrl) {
			window.open(pdfUrl, "_blank");
		  } else {
			console.error("PDF URL is not available");
		  }
		},
		async download(selectedItem) {
			try {
			await store.dispatch("outgoingDocuments/download", {
				id: selectedItem.id,
			});
			} catch (error) {
			console.error("Error downloading document:", error);
			}
		},
		navigateToAppeal() {
			if (this.selectedItem.request_id !== null) {
			this.$router.push({
				name: "appeals.view",
				params: {
					id: this.selectedItem.case_id,
					appeal_id: this.selectedItem.appeal_id,
					case_request_id: this.selectedItem.request_id,
					redirected: 'request'
				},
			});
			} else {
			this.$router.push({
				name: 'appeals.view',
				params: { id: this.selectedItem.case_id, appeal_id: this.selectedItem.appeal_id },
			});
			}
		},
	  async refresh() {
		try {
		  this.loading = true;
		  this.error = false;
		  if (this.value.request_id !== null) {
			const response = await this.$store.dispatch("caseRequests/get", {
			  case_id: this.value.case_id,
			  id: this.value.request_id,
			});
			this.caseRequest = response.data.data;
		  } else {
			const response = await this.$store.dispatch("appeals/get", {
			  case_id: this.value.case_id,
			  id: this.value.appeal_id,
			});
			this.appeal = response.data.data;
		  }
		} catch (e) {
		  this.error = true;
		} finally {
		  this.loading = false;
		}
	  },
	  async test() {
		const url = "/client/insuranceappeal";
		const response = await axios.get(url, {
		  headers: {
			"Accept": "application/json",
		  },
		});
		this.outgoingList = response.data;

		const requesturl = "/client/dashboardRequest";
		const requestresponse = await axios.get(requesturl, {
		  headers: {
			"Accept": "application/json",
		  },
		});
		
		this.requestList = requestresponse.data;
  
          

		const appealListUrl = '/client/appealList';
		const appealListResponse = await axios.get(appealListUrl, {
		  headers: {
			"Accept": "application/json",
		  },
		});
		this.appealList = appealListResponse.data;
  
		const agencyListUrl = '/client/agencyList';
		const agencyListResponse = await axios.get(agencyListUrl, {
		  headers: {
			"Accept": "application/json",
		  },
		});
		this.agencyList = agencyListResponse.data;
	  },
	  
},

	mounted() {
	  this.test();
	  this.refresh();
		if (this.$route.params.itemData) {
			this.selectedItem = this.$route.params.itemData;
	        this.showDetailsModal = true;
		};
	  
	}
  };
  </script>
  
  <style scoped>
 
  .circle-badge {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  line-height: 16px;
  border-radius: 50%;
  background-color: #007bff;
  color: white;
  text-align: center;
  font-size: 12px;
}
.circle-badger {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  line-height: 16px;
  border-radius: 50%;
  background-color: #ff0000; /* Change color as needed */
  color: white;
  text-align: center;
  font-size: 12px;
}
  </style>
  
